import { default as libphonenumber } from "google-libphonenumber";
import { AccountController } from "@/app/ui/controllers/AccountController";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
const PNF = libphonenumber.PhoneNumberFormat;

const DEFAULT_REGION = "ID";

function getRegion(countryCode?: string): string {
  const raw =
    countryCode?.toLowerCase() ||
    AccountController.accountData?.countryCode ||
    DEFAULT_REGION.toLowerCase();
  return raw.toUpperCase();
}

export const getPhoneDisplayCode = (countryCode?: string): string => {
  try {
    const region = getRegion(countryCode);
    const code = phoneUtil.getCountryCodeForRegion(region);
    if (code && code > 0) return `+${code}`;
    const defaultCode = phoneUtil.getCountryCodeForRegion(DEFAULT_REGION);
    return defaultCode ? `+${defaultCode}` : "+62";
  } catch {
    return "+62";
  }
};

const formatPhoneNumber = (phone: string, countryCode?: string): string => {
  if (!phone || String(phone).trim() === "") return "";
  const region = getRegion(countryCode);
  try {
    const parsed = phoneUtil.parse(phone, region);
    return phoneUtil.format(parsed, PNF.E164);
  } catch {
    return phone;
  }
};
export default formatPhoneNumber;
